"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaceObj = exports.isRTL = exports.hexToRgb = exports.getUniversalTypography = exports.getTypography = exports.getTypoWeight = exports.getTypoStyle = exports.getTypoSize = exports.getSpace = exports.getShadow = exports.getProps = exports.getPalette = exports.getBorderRadius = void 0;

var _themeGet = require("@styled-system/theme-get");

var _theme = _interopRequireDefault(require("../theme"));

var getPalette = function getPalette() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      theme: _theme["default"]
    };
    var color = args.length === 2 ? args[0] : props.color;
    var shade = args.length === 2 ? args[1] : args[0];
    return (0, _themeGet.themeGet)("palette.".concat(color, ".").concat(shade))(props) || color;
  };
};

exports.getPalette = getPalette;

var getTypography = function getTypography(typo) {
  return function (props) {
    var typography = props.theme.typography;
    return typography[typo] || '';
  };
};

exports.getTypography = getTypography;

var getTypoSize = function getTypoSize(type, size, value) {
  return function (props) {
    var typography = props.theme.typography;
    return typography.fontType[type][size][value] || '';
  };
};

exports.getTypoSize = getTypoSize;

var getTypoStyle = function getTypoStyle(style) {
  return function (props) {
    var typography = props.theme.typography;
    return typography.fontDecoration[style] || '';
  };
};

exports.getTypoStyle = getTypoStyle;

var getTypoWeight = function getTypoWeight(weight) {
  return function (props) {
    var typography = props.theme.typography;
    return typography.fontWeight[weight] || '';
  };
};

exports.getTypoWeight = getTypoWeight;

var getUniversalTypography = function getUniversalTypography(type, weight, size) {
  return function (props) {
    var generatedTypography = {};
    generatedTypography['font-weight'] = "".concat(getTypoWeight(weight)(props));
    generatedTypography['font-size'] = "".concat(getTypoSize(type, size, 'size')(props), "px");
    generatedTypography['line-height'] = "".concat(getTypoSize(type, size, 'lineHeight')(props), "px");
    return generatedTypography || '';
  };
};

exports.getUniversalTypography = getUniversalTypography;

var getShadow = function getShadow(key) {
  return function (props) {
    var shadows = props.theme.shadows;
    return shadows[key] || '';
  };
};

exports.getShadow = getShadow;

var getBorderRadius = function getBorderRadius(radius) {
  return function (props) {
    var borderRadius = props.theme.borderRadius;
    return "".concat(borderRadius[radius], "px") || '0px';
  };
};

exports.getBorderRadius = getBorderRadius;
var spaceObj = ['margin', 'm', 'marginTop', 'mt', 'marginRight', 'mr', 'marginBottom', 'mb', 'marginLeft', 'ml', 'marginX', 'mx', 'marginY', 'my', 'padding', 'p', 'paddingTop', 'pt', 'paddingRight', 'pr', 'paddingBottom', 'pb', 'paddingLeft', 'pl', 'paddingX', 'px', 'paddingY', 'py'];
exports.spaceObj = spaceObj;

var getProps = function getProps(props, cb) {
  return Object.keys(props).filter(function (key) {
    return cb(key);
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};

exports.getProps = getProps;

var hexToRgb = function hexToRgb(color, opacity) {
  color = color.substring(1);
  var colors = color.match(new RegExp(".{1,".concat(color.length / 3, "}"), 'g'));

  if (colors) {
    colors = colors.map(function (val) {
      return parseInt(val.length === 1 ? val + val : val, 16);
    }).join(', ');
  }

  return colors ? "rgb(".concat(colors, ",").concat(opacity, ")") : '';
};

exports.hexToRgb = hexToRgb;

var isRTL = function isRTL(props) {
  return props.theme.direction === 'rtl';
};

exports.isRTL = isRTL;

var getSpace = function getSpace(key) {
  return function (props) {
    var spaces = props.theme.spaces;
    return spaces[key] || 0;
  };
};

exports.getSpace = getSpace;